var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C77.6142 0 100 22.3858 100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0ZM22.0078 78.8955H34.6504V38.2197H22.0078V78.8955ZM66.835 37.208C60.6853 37.2081 56.5619 40.5799 54.874 43.7773H54.7051V38.2197H42.5791V78.8945H55.21V58.7725C55.21 53.4676 56.2207 48.3291 62.7979 48.3291C69.2801 48.3294 69.3672 54.3962 69.3672 59.1123V78.8936H82V56.584C82 45.6327 79.6367 37.208 66.835 37.208ZM28.332 18C24.2804 18 21.0007 21.2857 21 25.3281C21.0002 29.3742 24.2794 32.659 28.332 32.6592C32.3737 32.6592 35.658 29.3743 35.6582 25.3281C35.6582 21.2852 32.3736 18.0002 28.332 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract1);
export default __webpack_public_path__ + "static/media/Subtract(1).7e8e718cae721347afcb1b6a8025887d.svg";
export { ForwardRef as ReactComponent };